import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SelectOption } from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { DialogsService } from '../dialogs.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { HttpService } from '../../core/http/http.service';
import { NextMethodsEnum } from '../../core/enums/next-methods.enum';
import { PipesModule } from '../../core/pipes/pipes.module';

@Component({
    selector: 'new-form-dialog',
    templateUrl: './new-form-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatSelectModule, PipesModule, ReactiveFormsModule, TranslocoModule]
})

export class NewFormDialog implements OnInit {

    tipologyOptions: SelectOption[];

    tipologyControl: FormControl = new FormControl('', Validators.required);

    private readonly tipologyClass = 'com.cloudcodice.feature.dtype.facade.form.FormTypology';

    public dialogRef = inject(MatDialogRef<NewFormDialog>);
    private dialogsService = inject(DialogsService);
    private _fuseConfirmationService = inject(FuseConfirmationService);
    private httpService = inject(HttpService);
    private transloco = inject(TranslocoService);

    ngOnInit() {
        this.httpService.post<{ option: SelectOption[] }>(NextMethodsEnum.retrieveEnumerationType, { enumerationClass: this.tipologyClass })
            .subscribe(reply => this.tipologyOptions = reply.option);
    }

    getNewInstance() {
        const confirmDialog = this.openConfirmDialog();
        confirmDialog.afterClosed().subscribe((confirm) => {
            if (confirm === 'confirmed') {
                this.tipologyControl.markAsTouched();
                if (this.tipologyControl.valid) {
                    this.dialogRef.close(this.tipologyControl.value);
                } else {
                    this.dialogsService.openErrorDialog({
                        message: this.transloco.translate('errorsInForm')
                    });
                }
            }
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    private openConfirmDialog() {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: this.transloco.translate('formNewInstanceMsg'),
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
